import { getLoggerRef } from './logger-bridge';

export function installGlobalHandlers(): void {
  const existingOnerror = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    getLoggerRef()?.error(
      typeof message === 'string' ? message : 'Uncaught error',
      error ?? undefined,
      { source, lineno, colno },
    );
    if (typeof existingOnerror === 'function') {
      return existingOnerror.call(window, message, source, lineno, colno, error);
    }
    return false;
  };

  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason instanceof Error ? event.reason : undefined;
    const message = error?.message ?? String(event.reason ?? 'Unhandled promise rejection');
    getLoggerRef()?.error(message, error, { source: 'unhandledrejection' });
  });
}
